import React from 'react'

import "./info.css"
import view from "../../../assets/images/homepage/View1.jpeg"

export default function Info() {
  return (
    <div className='emas__home-info'>
      <div className='emas__home-info_container'>
          <h1>Welcome to Electricity Market Advisory Services</h1>
          <p> We specialise in modelling electricity markets. While our focus is on the Western Australian wholesale electricity market, we also undertake financial modelling of electricity network and retail businesses. We have a range of models that can be used for financial analysis, simulations and forecasts. We also create bespoke models to meet your business needs.</p>
          <p> The complexity of the market continues to increase as renewable energy becomes a greater share of generation. Our modelling can help you navigate this complexity.</p>
      </div>
      <div className='emas__home-info_image' >
        <img src={view} alt="view from Fremantle"/>
      </div>
    </div>
  )
}
